<template>
  <div class="down-box">
    <img src="../assets/logo.jpg" class="logo-icon" />
    <div class="down-box-x">
      <p class="andriod" @click="donwAndroid">
        <img src="../assets/安卓.png" class="a-icon" alt="" />
        Andriod版下载
      </p>

      <p class="andriod" style="margin-top: 32px; margin-bottom: 32px" @click="downIos">
        <img src="../assets/苹果.png" class="a-icon" alt="" />
        iphone版下载
      </p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    async donwAndroid() {
      let { data } = await this.axios.get("/startNFT/api/user/home/getAndroidDownloadUrl");
      if (data.code == 200) {
        let anUrl = data.data;
        window.open(anUrl);
      }
    },
    downIos() {
      let iosHttps = "https://apps.apple.com/cn/app/%E5%A4%A9%E8%89%BA%E7%A9%BA%E9%97%B4/id1604580436";
      window.open(iosHttps);
    },
  },
};
</script>

<style scoped>
.down-box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("../assets/new/bg.png") no-repeat;
  background-size: 100%;
}

.logo-icon {
  width: 17rem;
  height: 17rem;
  margin-top: 10vh;
  margin-left: 50%;
  transform: translateX(-50%);
}

.down-box-x {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 3rem;
  position: absolute;
  bottom: 1rem;
}

.andriod {
  width: 44rem;
  background: #fcfcfc;
  height: 8.6rem;
  border: 0;
  border-radius: 4.3rem;
  font-size: 3rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.a-icon {
  width: 4.3rem;
  height: 4.3rem;
  margin-right: 1.5rem;
}
</style>
